import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Leave } from 'src/app/classes/leave';
import { User } from 'src/app/classes/user.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { LeaveService } from 'src/app/services/leave.service';
import { UserService } from '../../services/user/user.service';

@Component({
    selector: 'app-leave',
    templateUrl: './leave.component.html',
    styleUrls: ['./leave.component.scss'],
    standalone: false,
})
export class LeaveComponent extends CodaltComponent implements OnInit {
    leaves: Leave[];
    filteredLeaves: Leave[];
    users: User[] = [];
    now = new Date();
    fcShowHistoric = new FormControl(false);
    fcUsers = new FormControl<number[]>([]);

    constructor(
        private leaveService: LeaveService,
        private confirmDialog: ConfirmDialogService,
        private userService: UserService,
        private router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.getLeaves();

        this.subscriptions.add(
            this.fcShowHistoric.valueChanges.subscribe(() => {
                this.getLeaves();
            })
        );
        this.subscriptions.add(
            this.userService.getList().subscribe(users => {
                this.users = users;
            })
        );

        this.subscriptions.add(
            this.fcUsers.valueChanges.subscribe(() => {
                this.filterLeaves();
            })
        );
    }

    private getLeaves() {
        this.subscriptions.add(
            this.leaveService.getLeaves(this.fcShowHistoric.value).subscribe(leaves => {
                this.leaves = leaves.data;
                this.filterLeaves();
            })
        );
    }
    private filterLeaves() {
        const selectedUserIds = this.fcUsers.value;
        if (!selectedUserIds || selectedUserIds.length === 0) {
            this.filteredLeaves = this.leaves;
        } else {
            this.filteredLeaves = this.leaves.filter(leave => {
                if (leave.common) {
                    return true;
                }
                return leave.users?.some(user => selectedUserIds.includes(user.id));
            });
        }
    }

    edit(leave?: Leave) {
        this.router.navigateByUrl(`/leave/${leave?.id ?? 'new'}`);
    }

    delete(event, leave?: Leave) {
        event.stopPropagation();

        this.confirmDialog
            .confirm({
                title: 'Verlof verwijderen',
                text: `Weet u zeker dat u verlof ${leave.comment} wilt verwijderen?`,
                confirm: 'Verwijderen',
                cancel: 'Annuleren',
            })
            .then(
                confirm => {
                    this.leaveService.deleteLeave(leave.id).subscribe(() => {
                        this.getLeaves();
                    });
                },
                () => {}
            );
    }
}
